// extracted by mini-css-extract-plugin
export default {"wrapper":"Index_wrapper__yGzVJ","blocks":"Index_blocks__Qjud4","columns":"Index_columns__9hdi+","column":"Index_column__9HqEh"};